const stringToNumArray = (str) => {
    if (str === undefined || str === null) {
        return;
    }
    const arr = str
        .toString()
        .replace(/[^\d.,]/g, "")
        .split(",")
        .map((v) => parseFloat(v));
    return arr.some(isNaN) ? null : arr;
};

export const stringToPctAsDecimalArray = (str) => {
    if (str === undefined || str === null) {
        return;
    }
    const arr = str
        .toString()
        .replace(/[^\d.,]/g, "")
        .split(",")
        .map((v) => parseFloat(v));
    let array = arr.some(isNaN) ? null : arr;
    let convertToDecimal = [];
    if (array === null) {
        return null;
    } else {
        array.forEach(pct => convertToDecimal.push(pct / 100))
        return convertToDecimal;
    }
};

export const stringToDecimalAsPctArray = (str) => {
    if (str === undefined || str === null) {
        return;
    }
    const arr = str
        .toString()
        .replace(/[^\d.,]/g, "")
        .split(",")
        .map((v) => parseFloat(v));
    let array = arr.some(isNaN) ? null : arr;
    let convertToDecimal = [];
    if (array === null) {
        return null;
    } else {
        array.forEach(pct => convertToDecimal.push(pct * 100))
        return convertToDecimal;
    }
};

export default stringToNumArray;
